'use strict';

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Form = require('material-ui/Form');

var _Menu = require('material-ui/Menu');

var _Select = require('material-ui/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Input = require('material-ui/Input');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return (0, _from2.default)(arr); } }

var DropDownMenu = function DropDownMenu(_ref) {
  var input = _ref.input,
      formLabel = _ref.label,
      helperText = _ref.helperText,
      required = _ref.required,
      multiple = _ref.multiple,
      options = _ref.options,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;

  var displayedOptions = !required ? [{
    label: '',
    value: null
  }].concat(_toConsumableArray(options)) : options;

  return _react2.default.createElement(
    _Form.FormControl,
    { fullWidth: true },
    _react2.default.createElement(
      _Input.InputLabel,
      { required: required, error: Boolean(touched && error) },
      formLabel
    ),
    _react2.default.createElement(
      _Select2.default,
      {
        multiple: multiple,
        value: input.value || [],
        onChange: input.onChange
      },
      displayedOptions.map(function (_ref2) {
        var label = _ref2.label,
            value = _ref2.value;
        return _react2.default.createElement(
          _Menu.MenuItem,
          {
            className: 'form-field-dropdown-menu-item',
            key: value || 'deselect',
            value: value,
            style: {
              fontWeight: input.value.indexOf(value) !== -1 ? '500' : 'initial',
              backgroundColor: input.value.indexOf(value) !== -1 ? 'rgba(0, 0, 0, 0.12)' : 'initial'
            }
          },
          label || ''
        );
      })
    ),
    (helperText || touched && error) && _react2.default.createElement(
      _Form.FormHelperText,
      {
        error: Boolean(touched && error)
      },
      touched && error ? error : helperText
    )
  );
};

DropDownMenu.propTypes = {
  input: _propTypes2.default.object.isRequired,
  label: _propTypes2.default.node.isRequired,
  options: _propTypes2.default.array.isRequired,
  helperText: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  multiple: _propTypes2.default.bool,
  meta: _propTypes2.default.object.isRequired
};

DropDownMenu.defaultProps = {
  helperText: undefined,
  required: false,
  multiple: false
};

exports.default = DropDownMenu;